// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13228(a2d7192c27)-C13/10/2026-12:02:17-B13/10/2026-12:08:45' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13228(a2d7192c27)-C13/10/2026-12:02:17-B13/10/2026-12:08:45",
  branch: "test",
  latestTag: "8.1",
  revCount: "13228",
  shortHash: "a2d7192c27",
  longHash: "a2d7192c273a7e3c83ec5858996a4fba38d55c37",
  dateCommit: "13/10/2026-12:02:17",
  dateBuild: "13/10/2026-12:08:45",
  buildType: "Ansible",
  } ;
